'use strict';

var axs = require('./axs');

var style = {
  display: 'flex'
};

var Flex = axs(style)('div');

Flex.center = axs({
  display: 'flex',
  alignItems: 'center'
})('div');

Flex.wrap = axs({
  display: 'flex',
  flexWrap: 'wrap'
})('div');

module.exports = Flex;


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/Flex.js
// module id = 101
// module chunks = 0